module.exports = __webpack_public_path__ + "media/images/front/img_ad_receipt-6523ca8a1e38fff86189e19e369ec96a.png";